import axios from "axios";

export default {
  namespaced: true,
  state: {
    customers: [],
    actives: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    customersMessage: ''
  },
  mutations: {
    RECEIVED_CUSTOMERS(state, payload) {
      state.customers = payload;
      state.isReceiving = false;
    },
    RECEIVED_ACTIVES(state, payload) {
      state.actives = payload;
      state.isReceiving = false;
    },
    RECEIVING_CUSTOMERS(state) {
      state.isReceiving = true;
    },
    RECEIVED_CUSTOMER(state, payload) {
      state = Object.assign(state, {
        customers: [...state.customers, payload],
        isReceiving: false,
      })
    },
    RECEIVING_CUSTOMER(state) {
      state.isReceiving = true;
    },
    UPDATED_CUSTOMER(state, payload) {
      let index = state.customers.findIndex(customer => customer._id === payload._id);
      state = Object.assign(state, {
        customers: state.customers.map((customer, i) => {
          if (i === index) {
            return Object.assign({}, customer, payload);
          }
          return customer;
        }),
        isUpdating: false,
        customersMessage: 'Customers has been updating!',
      })
    },
    UPDATING_CUSTOMER(state) {
      state.isUpdating = true;
    },
    DELETED_CUSTOMER(state, payload) {
      let indexToDelete = state.customers.findIndex(customer => customer._id === payload._id);
      let customers = [...state.customers];
      customers.splice(indexToDelete, 1);
      state = Object.assign(state, {
        customers: [...customers],
        isDeleting: false,
        idToDelete: null,
        customersMessage: 'Customer has been Deleted!',
      });
    },
    DELETING_CUSTOMER(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    createCustomerRequest({dispatch}, payload) {
      dispatch("receivingCustomers");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');

      if(payload.customerimage !== undefined) {
        url = 'https://api.tradexc.com:3000/insert/customer/image';
        data = new FormData();
        data.append('image', payload.customerimage, payload.imagename); 
        delete payload['customerimage'];
        for (let x in payload) {
          data.append(x, payload[x]);
        }
        header = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        };
      } else {
        url = 'https://api.tradexc.com:3000/insert/customer';
        data = payload;
        header = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        };
      }
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (res) {
        dispatch("receiveCustomer", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    async deleteCustomerRequest({dispatch}, payload) {
      console.log("H", payload)
      dispatch("deletingCustomer", payload);
      return axios.delete('https://api.tradexc.com:3000/delete/customer/' + payload._id)
      .then(() => {
        dispatch("deleteCustomer", {_id: payload._id});
      })
    },
    async getCustomersRequest({dispatch}) {
      dispatch("receivingCustomers");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/customers';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: headers})
      .then(response => {
        dispatch("receiveCustomers", response.data);
      })
    },
    async getCustomersActiveRequest({dispatch}) {
      dispatch("receivingCustomers");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/customers/active';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(response => {
        dispatch("receiveActives", response.data);
      })
    },
    async getCustomersAllRequest({dispatch}) {
      dispatch("receivingCustomers");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/customers/all';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(response => {
        dispatch("receiveCustomers", response.data);
      })
    },
    async findCustomersQueryRequest({dispatch}, payload) {
      console.log(payload)
      try{
        dispatch("receivingCustomers");
        let token = localStorage.getItem('token');
        console.log(payload)
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/customers/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveCustomers", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findCustomersShortQueryRequest({dispatch}, payload) {
      console.log(payload)
      try{
        dispatch("receivingCustomers");
        let token = localStorage.getItem('token');
        console.log(payload)
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/customers/short/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveCustomers", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findCustomersActiveQueryRequest({dispatch}, payload) {
      console.log(payload)
      try{
        dispatch("receivingCustomers");
        let token = localStorage.getItem('token');
        console.log(payload)
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/customers/active/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveActives", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertCustomerProfileRequest({dispatch}, payload) {
      try{
        dispatch("receivingCustomer");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/customerprofile/' + payload.customerid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveCustomer");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateCustomerRequest({dispatch}, payload) {
      dispatch("updatingCustomer");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/customer/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      try {
        let response = await axios({method: 'put', url: url, headers: headers, data: payload});
        dispatch("updateCustomer", response.data);
        return response.data;
      } catch (error) {
        console.error('Error:', error);
        this.alertmessage = error;
      }
    },
    updateCustomerImageRequest({dispatch}, payload) {
      dispatch("updatingCustomer");
      let data;
      let headers;
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.tradexc.com:3000/update/customer/image/' + id;
      data = new FormData();
      data.append('image', payload.customerimage, payload.imagename); 
      delete payload['customerimage'];
      for (let x in payload) {data.append(x, payload[x])}
      headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      axios({method: "PUT", url: url, headers: headers, data: data})
      .then( (response)=> {
        dispatch("updateCustomer", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updateCustomerInvoiceSendRequest({dispatch}, payload) {
      dispatch("updatingCustomer");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/customer/open-invoices/send/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updatingCustomer", response.data);
      return response.data;
    },
    receiveCustomers({commit}, payload) {
      commit("RECEIVED_CUSTOMERS", payload)
    },
    receiveActives({commit}, payload) {
      commit("RECEIVED_ACTIVES", payload)
    },
    receivingCustomers({commit}) {
      commit("RECEIVING_CUSTOMERS")
    },
    receiveCustomer({commit}, payload) {
      commit("RECEIVED_CUSTOMER", payload)
    },
    receivingCustomer({commit}) {
      commit("RECEIVING_CUSTOMER")
    },
    updateCustomer({commit}, payload) {
      commit("UPDATED_CUSTOMER", payload)
    },
    updatingCustomer({commit}) {
      commit("UPDATING_CUSTOMER")
    },
    deleteCustomer({commit}, payload) {
      commit("DELETED_CUSTOMER", payload)
    },
    deletingCustomer({commit}, payload) {
      commit("DELETING_CUSTOMER", payload)
    }
  },
};
